export const EVENT_TYPES = [
  "Atelier collectif",
  "Permanence individuelle",
  "Évènement / Reunion / Forum",
  "Formation",
  "Rencontre réseaux",
  "Immersion / Rencontre terrain"
];
